var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3.33333V10.8333C15 11.2917 14.625 11.6667 14.1667 11.6667H5.83333L3.67521 13.8248C3.02818 14.4718 2.5 14.2516 2.5 13.3285V3.33333C2.5 2.875 2.875 2.5 3.33333 2.5H14.1667C14.625 2.5 15 2.875 15 3.33333ZM8.33333 15C7.8731 15 7.5 14.6269 7.5 14.1667C7.5 13.7064 7.8731 13.3333 8.33333 13.3333H14.5118L16.6667 15.4882V5C16.6667 4.53976 17.0398 4.16667 17.5 4.16667C17.9602 4.16667 18.3333 4.53976 18.3333 5V15.4882C18.3333 15.9302 18.1577 16.3541 17.8452 16.6667C17.1943 17.3175 16.139 17.3175 15.4882 16.6667L13.8215 15H8.33333ZM13.3333 10H5.14298L4.16667 10.9763V4.16667H13.3333V10Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_70_2243",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 17,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3.33333V10.8333C15 11.2917 14.625 11.6667 14.1667 11.6667H5.83333L3.67521 13.8248C3.02818 14.4718 2.5 14.2516 2.5 13.3285V3.33333C2.5 2.875 2.875 2.5 3.33333 2.5H14.1667C14.625 2.5 15 2.875 15 3.33333ZM8.33333 15C7.8731 15 7.5 14.6269 7.5 14.1667C7.5 13.7064 7.8731 13.3333 8.33333 13.3333H14.5118L16.6667 15.4882V5C16.6667 4.53976 17.0398 4.16667 17.5 4.16667C17.9602 4.16667 18.3333 4.53976 18.3333 5V15.4882C18.3333 15.9302 18.1577 16.3541 17.8452 16.6667C17.1943 17.3175 16.139 17.3175 15.4882 16.6667L13.8215 15H8.33333ZM13.3333 10H5.14298L4.16667 10.9763V4.16667H13.3333V10Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_70_2243)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.3bb0c4a329609c96c5afec2eabf1df62.svg";
export { ForwardRef as ReactComponent };